module.exports = "pegasus_template/assets/blocks/capture-2-themecapture1.png";